import RNEvent from '/@/kernel-mn/utils/RNEvent';
import { isApp } from "/@/kernel-mn/utils";
import config from '/@/kernel-mn/config';
import router from '/@/router';
import { useGameStore } from '/@/kernel-mn/stores/game';
import { formatIMSport, testCanPlay } from '/@/plugins/game';
import { mb_toast, mb_t } from './global'

const linkJump = item => {
  if (Math.round(item.terrace_id) < 0) {
    if (Math.round(item.terrace_id)) {
      if (Math.round(item.play_id) === -1) {
        if (Math.round(item.terrace_id) === -1) {
          if (item.terrace_name.search('彩票') !== -1) {
            router.push('/game?key=lottery');
          } else {
            router.push('/game?key=lottery');
            return;
          }
        }
        if (Math.round(item.terrace_id) === -2) {
          router.push('/game?key=chess');
        } else if (Math.round(item.terrace_id) === -3) {
          router.push('/game?key=electronic');
        } else if (Math.round(item.terrace_id) === -4) {
          router.push('/game?key=live');
        } else if (Math.round(item.terrace_id) === -5) {
          router.push('/game?key=fishing');
        } else if (Math.round(item.terrace_id) === -6) {
          router.push('/game?key=sports');
        } else if (Math.round(item.terrace_id) === -7) {
          router.push('/game?key=block');
        }
      } else {
        // 匹配默认选中的哪个，和chomeelot.js中的 gamesType 中的死值的数组的下标对应起来
        let index = 0;
        if (item.play_cname.indexOf('蛋蛋') >= 0) {
          index = 1;
        } else if (item.play_cname.indexOf('赛车') >= 0) {
          index = 2;
        } else if (item.play_cname.indexOf('时时彩') >= 0) {
          index = 3;
        } else if (item.play_cname.indexOf('11选5') >= 0) {
          index = 4;
        } else if (item.play_cname.indexOf('六合彩') >= 0) {
          index = 5;
        } else if (item.play_cname.indexOf('快3') >= 0) {
          index = 6;
        } else if (item.play_cname.indexOf('飞艇') >= 0) {
          index = 7;
        } else if (item.play_cname.indexOf('澳洲') >= 0 || item.play_cname.indexOf('台湾') >= 0) {
          index = 8;
        }
        if (index > 0) {
          const gameStore = useGameStore()
          gameStore.changeSelectedType(index);
        }
        if ((item.headName && item.headName.search('彩票') !== -1) || item.terrace_name.search('彩票') !== -1) {
          let args = config.getPlayInfo(item.play_id);
          args.state = item.state;
          testCanPlay(args);
        } else if (item.terrace_name.search('棋牌') !== -1) {
          router.push('/game?key=chess');
        }
      }
    } else {
      if (Math.round(item.play_id) === -1) {
        router.push('/game?key=chess');
      } else {
        gameJump(item);
      }
    }
  } else {
    if (Math.round(item.play_id) === -1) {
      let tab = 'lottery';
      if (item.terrace_name.search('棋牌') !== -1) {
        tab = 'chess';
      } else if (item.terrace_name.search('电子') !== -1) {
        tab = 'electronic';
      } else if (item.terrace_name.search('捕鱼') !== -1) {
        tab = 'fishing';
      } else if (item.terrace_name.search('体育') !== -1 || item.terrace_name.search('赛马') !== -1 || item.terrace_name.search('球') !== -1) {
        tab = 'sports';
      } else if (item.terrace_name.search('真人') !== -1 || item.terrace_name.search('视讯') !== -1) {
        tab = 'live';
      } else if (item.terrace_name.search('game') !== -1) {
        switch (item.terrace_name) {
          case 'crashgame':
            router.push('/crash');
            break;
          case 'minegame':
            router.push('/mines');
            break;
          case 'dabblegame':
            router.push('/double');
            break;
          case 'dicegame':
            router.push('/dice');
            break;
        }
        return;
      }
      router.push(`/game?key=${tab}&upper_play_id=${item.terrace_id}`);
    } else {
      gameJump(item);
    }
  }
};
const goGame = item => {
  item.play_id = item.game;
  item.terrace_id = item.platform;
  item.gtype = item.gtype || '';
  item.terrace_name = getTerraceName(Number(item.game_type));
  if (item.platform < 0 && Number(item.game_type) === 100) {
    let args = config.getPlayInfo(item.game);
    args && (item.play_cname = args.play_cname || '');
  }
  linkJump(item);
};
const getTerraceName = val => {
  const terraceName = {
    100: '彩票', // 100彩票
    101: '棋牌', // 101棋牌
    102: '电子', // 102电子
    103: '真人', // 103真人
    104: '捕鱼', // 104捕鱼
    105: '体育', // 105体育
    108: '红包' // 108红包
  };
  return terraceName[val];
};
const goTask = (item, activeConfiguration) => {
  const taskTypes = {
    1: 101, // 1充值大礼包
    2: 102, // 2有玩就有礼
    3: 106, // 3分享领工资
    4: 103, // 4亏损救援金
    5: 110, // 5游戏任务
    6: 113, // 活动彩金
    7: 114, // 幸运大转盘
    8: 112 // 会员任务
  };
  const gameType = {
    1: 4, // 1彩票
    2: 1, // 2棋牌
    3: 2, // 3电子
    4: 6, // 4真人
    5: 3, // 5捕鱼
    6: 5, // 6体育
    7: 7 // 7红包
  };
  if (Number(taskTypes[item.task_type]) === 110 && gameType[item.game_task_class]) {
    router.push('/task?type=1&taskType=' + taskTypes[5] + '&gameType=' + gameType[Number(item.game_task_class)]);
  } else if (Number(taskTypes[item.task_type]) === 114 && gameType[item.game_task_class]) {
    // 暂时没有大转盘
  } else {
    if (taskTypes[Number(item.task_type)]) {
      if (taskTypes[Number(item.task_type)] === 113) {
        if (!activeConfiguration.value['50']) {
          mb_toast(mb_t('当前暂无活动'));
          return;
        }
      }
      router.push('/task?type=1&taskType=' + taskTypes[Number(item.task_type)]);
    } else {
      router.push('/task?type=1&taskType=110');
    }
  }
};


export function doJump(item, activeConfiguration) {
  const mb_RNEvent = RNEvent.getInstance();
  if (item.content_type === 3) {
    if (isApp()) {
      mb_RNEvent.sendNativeMsg('url:' + item.content);
    } else {
      window.open(item.content);
    }
    return;
  }
  if (item.content_type === 4) {
    if (item.link_type === 1) {
      goGame(item);
    } else if (item.task_type === 7) {
      // if (item.bulletin_id === 6696) {
      // 幸运大转盘
      router.push('/bigturntable');
      return;
      // }
    } else {
      goTask(item, activeConfiguration);
    }
  }

}